import { DateUtil, isNullOrUndefined, EqualityInterface } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import { ReservationStatus } from './reservation-status';
import { RideRequestLocationDetail } from './ride-request-location-detail';
import { RideRequestType } from './ride-request-type';

export class RideInfo implements EqualityInterface<RideInfo> {
  @autoserialize id: number;
  @autoserialize rideRequestId: number;
  @autoserialize reservationId: number;
  @autoserialize itineraryId: number;
  @autoserializeAs(RideRequestType) rideRequestType: RideRequestType;
  @autoserializeAs(RideRequestLocationDetail) pickupLocation: RideRequestLocationDetail;
  @autoserializeAs(RideRequestLocationDetail) dropoffLocation: RideRequestLocationDetail;
  @autoserializeAs(Date) pickupDate: Date;
  @autoserializeAs(Date) dropoffDate: Date;
  @autoserialize timeZone: string;
  @autoserialize durationEstimate: number;
  @autoserialize favoriteDriver: boolean;
  @autoserialize vehicleInspectionRequired: boolean;
  @autoserializeAs(ReservationStatus) reservationStatus: ReservationStatus;

  get assigned(): boolean {
    return !isNullOrUndefined(this.reservationId);
  }

  public static OnSeserialized(instance: RideInfo, json: any): void {
    if (!isNullOrUndefined(json['pickupDate'])) {
      json['pickupDate'] = DateUtil.serializeDate(instance.pickupDate);
    }

    if (!isNullOrUndefined(json['dropoffDate'])) {
      json['dropoffDate'] = DateUtil.serializeDate(instance.dropoffDate);
    }
  }

  public static OnDeserialized(instance: RideInfo, json: any): void {
    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeDate(json['pickupDate']);
    }

    if (!isNullOrUndefined(json['dropoffDate'])) {
      instance.dropoffDate = DateUtil.deserializeDate(json['dropoffDate']);
    }
  }

  /**** Equality ****/

  equals(comparisonObject: RideInfo): boolean {
    if (isNullOrUndefined(comparisonObject)) {
      return false;
    }

    if (!isNullOrUndefined(this.reservationId)) {
      return this.reservationId === comparisonObject.reservationId;
    }

    return this.rideRequestId === comparisonObject.rideRequestId;
  }
}
